import { Directive } from '@angular/core';

@Directive({ selector: '[govukLabel]', standalone: true })
export class LabelDirective {}
